import React, { useState } from "react";
import PhoneNumberInput from "../../../components/PhoneNumberInput";
import SendSmsButton from "../../../components/SendSmsButton/SendSmsButton";
import { useFormContext } from "react-hook-form";
import { Alert, Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import FormLayoutHeader from "../../../layoutComponents/FormLayout/FormLayoutHeader";
import PinInput from "../../../components/PinInput";

const SmsConfirmation = () => {
	const {
		formState: { errors },
		setError,
		reset,
		control,
		setValue,
		getFieldState,
		getValues,
		watch,
	} = useFormContext();
	const [isPhoneInputDisabled, setIsPhoneInputDisabled] = useState<boolean>(false);
	const [pinIsDisabled, setPinIsDisabled] = useState<boolean>(true);

	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<div>
			<FormLayoutHeader title="Ověření" />

			<Box sx={{ marginBottom: "1.5rem", lineHeight: "24px" }}>
				<Typography variant="body1" gutterBottom>
					Doplňte mobilní telefon, na který vám pošleme SMS s kódem pro potvrzení.
				</Typography>
			</Box>
				<PhoneNumberInput
					name="phoneNumber"
					control={control}
					label="Mobilní telefon"
					reset={reset}
					errors={errors}
					defaultValue=""
					setValue={setValue}
					tabValue={1}
					disabled={isPhoneInputDisabled}
				/>

				<Box sx={{ marginBottom: "1rem" }}>
					<SendSmsButton
						setError={setError}
						getValues={getValues}
						getFieldState={getFieldState}
						errors={errors}
						watch={watch}
						tabValue={2}
						setIsDisabled={setIsPhoneInputDisabled}
						sentCallback={() => setPinIsDisabled(false)}
					/>
				</Box>

				<Box sx={{ height: "24px" }}></Box>
				{!pinIsDisabled && (
					<Box>
						<Typography align="center" variant="body1" gutterBottom>
							Zaslali jsme vám kód k ověření vašeho telefonního čísla:
						</Typography>
						<PinInput
							device={smDown ? "mobile" : "desktop"}
							gutterBottom
							name="pin"
							control={control}
							disabled={pinIsDisabled}
							errors={errors}
						/>
					</Box>
				)}
			{errors.root?.serverError.type === "ERR_BAD_RESPONSE" && <Alert severity="error">server response message</Alert>}
		</div>
	);
};

export default SmsConfirmation;
